module.exports = __webpack_public_path__ + "static/sara-86a4ad112a2ca67b6cb4798f7b85510a.png";